import { MutableRefObject, useEffect, useRef, useState } from "react"
import { Note } from "../../../Data/HexMap/Note"
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap"
import { NotesSelect } from "../../../Comps/NoteButtons/NotesSelect"
import { PositionSelector } from "../../../Util/PositionSelector/PositionSelector"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage"
import { NotePlayer } from "../../../Sound/NotePlayer"
import { useNotePlayer } from "../../../Sound/SoundStore"
import { Chords } from "../../../Util/Music/Chords"


export function ChordBuilderExercise(){
    const notePlayer:NotePlayer = useNotePlayer()
    useEffect(()=>{notePlayer.reset()},[])
    const positionSelector:MutableRefObject<PositionSelector> = useRef(new PositionSelector())
    const getNextPosition = () => {
        const nextPosition:number = positionSelector.current.getRandomPosition()
        return(nextPosition)
    }
    const getChordNotes = (rootPosition:number) => {
        const third:number = (rootPosition + 2) % 7
        const fifth:number = (rootPosition + 4) % 7
        return [rootPosition, third, fifth]
    }
    const [tonic, setTonic] = useState(0)
    const chordPosition:MutableRefObject<number> = useRef(positionSelector.current.getRandomPosition(-1))
    const chordNotes:MutableRefObject<number[]> = useRef(getChordNotes(chordPosition.current))
    const answers:MutableRefObject<number[]> = useRef([])
    const [answerMessage, setAnswerMessage] = useState<string>('')
    const [answerStatus, setAnswerStatus] = useState<boolean|null>(null)
    const [hilitedNotes, setHilitedNotes] = useState<number[]>([])
    const update = () => {setHilitedNotes([...answers.current])}
    const resetTonic = (keyTonic:number) => {
        setTonic(keyTonic)
        resetQuestion(keyTonic)
    }
    const onTonicSelect = (tonic:number) => {
        resetTonic(tonic)
    }
    const resetQuestion = (keyTonic:number) => {
        notePlayer.reset()
        const nextPosition:number = getNextPosition()
        chordPosition.current = nextPosition
        chordNotes.current = getChordNotes(nextPosition)
        answers.current = []
        setAnswerMessage('')
        setAnswerStatus(null)
        update()
    }
    const clearAnswerMessage = () => {
        const clear = () => {
            setAnswerMessage('')
            setAnswerStatus(null)
        }
        setTimeout(clear, 700)
    }
    const onNoteSelect = (noteData:Note) => {
        const answerCount:number = answers.current.length
        const nextAnswer:number = chordNotes.current[answerCount]
        if(nextAnswer === noteData.params.noteIndex){
            notePlayer.playNote(noteData.params.tonic)
            answers.current.push(noteData.params.noteIndex)
            setAnswerMessage('Correct!')
            setAnswerStatus(true)
            clearAnswerMessage()
            checkIfChordAnswersAreComplete()
            update()
        }
        else{
            notePlayer.playBuzzer()
            setAnswerMessage('Incorrect. Try again.')
            setAnswerStatus(false)
            clearAnswerMessage()
        }
    }
    const onQuestionComplete = () => {
        notePlayer.reset()
        const chordNoteTonics:number[] = Chords.GetChordNoteTonics(tonic, chordPosition.current,[0,2,4])
        setTimeout(()=>{notePlayer.playChord(chordNoteTonics)},1000)
        setTimeout(resetQuestion, 3000)
    }
    const checkIfChordAnswersAreComplete = () => {
        const notesAreComplete:boolean = (answers.current.length === chordNotes.current.length)
        if(notesAreComplete){
            setAnswerMessage('The chord is complete')
            setAnswerStatus(true)
            onQuestionComplete()
        }
        else{

        }
    }
    const getMessage = () => {
        return (
            `Define the notes of the ${chordPosition.current + 1} chord in order.`           
        )
    }

    return( 
        <OutlineBox title={'Chord Builder Exercise'} width={600}>
            <div id='chord-builder-component'>
                <NotesSelect onChange={onTonicSelect} tonic={tonic}/>
                    <div>
                        <ExerciseMessage key={getMessage()} answerStatus={null} message={getMessage()}/>
                        <div>
                            <HxChildMap tonic={tonic} radius={110}
                                        width={300} height={300} 
                                        hilitedNotes={hilitedNotes} 
                                        definedNotes={[]} 
                                        onNoteClick={onNoteSelect}
                                        onKeyClick={()=>{}}/>
                        </div> 
                        
                        {answerMessage != '' && <div style={{position:'absolute', top:'125px', width:'100%'}}>
                            <ExerciseMessage answerStatus={answerStatus} message={answerMessage}/>
                        </div>}
                    </div>                
            </div>
        </OutlineBox>
    )
}